export const OPEN_EXTERNAL_COLLABORATION = 'Opened External Sharing Page';
